









/**
 * 该组件由于迁徙时TS与js差异，导致js使用组件在TS中无法使用，估暂放弃这一需求，待有缘人开发
 */
import Vue from 'vue';
import Qrcode from 'qrcode.vue'
import { Component, Prop } from 'vue-property-decorator';
@Component({
  components: {
    Qrcode
  }
})
export default class QQrcode extends Vue {
    @Prop({
        type: String,
        default() {
            return '二维码'
        }
    })
    title!: String
    @Prop({
        type: String,
        default() {
            return ''
        }
    })
    url!: string
    private dialogVisible = false
}
